import Model from "./Model";
import Asset from "./Asset";
import {IncomeType} from "./Income";
import IModelItem from "./IModelItem";

export enum AssetConversionType {
  RothConversion = "RothConversion",
  QCD = "QualifiedCharitableDistribution",
  OtherConversion = "OtherConversion"
}

interface IAssetConversion {
  id: string
  createdAt: string
  updatedAt: string
  accountId: string
  userId: string
  modelId: string
  description: string
  conversionType: AssetConversionType
  srcAssetId: string
  dstAssetId: string
  year: number
  amount: number
  percent: number
  sortOrder: number
  completedAt: string
  taxableAmount: number // Depracated
  nonTaxableAmount: number
  incomeType: IncomeType
  archived: boolean
}

class AssetConversion implements IModelItem, IAssetConversion {
  id: string
  createdAt: string
  updatedAt: string
  accountId: string
  userId: string
  modelId: string
  model?: Model
  description: string
  conversionType: AssetConversionType
  srcAssetId: string
  srcAsset?: Asset
  dstAssetId: string
  dstAsset?: Asset
  year: number
  amount: number
  percent: number
  sortOrder: number
  completedAt: string
  taxableAmount: number // Depracated
  nonTaxableAmount: number
  incomeType: IncomeType
  archived: boolean

  constructor (data: any) {
    this.id = data.id
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.accountId = data.accountId
    this.userId = data.userId
    this.modelId = data.modelId
    this.description = data.description
    this.conversionType = data.conversionType ?? AssetConversionType.OtherConversion
    this.model = data.model
    this.srcAssetId = data.srcAssetId
    this.dstAssetId = data.dstAssetId
    this.year = data.year
    this.amount = data.amount
    this.percent = data.percent
    this.sortOrder = data.sortOrder
    this.completedAt = data.completedAt
    this.taxableAmount = data.taxableAmount
    this.nonTaxableAmount = data.nonTaxableAmount ?? 0
    this.incomeType = data.incomeType
    this.archived = data.archived === true
  }

  getTypename(): string {
    return "AssetConversion"
  }

  toJSON(): IAssetConversion {
    return {
      id: this.id,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      accountId: this.accountId,
      userId: this.userId,
      modelId: this.modelId,
      description: this.description,
      conversionType: this.conversionType,
      srcAssetId: this.srcAssetId,
      dstAssetId: this.dstAssetId,
      year: this.year,
      amount: this.amount,
      percent: this.percent,
      sortOrder: this.sortOrder,
      completedAt: this.completedAt,
      taxableAmount: this.taxableAmount,
      nonTaxableAmount: this.nonTaxableAmount,
      incomeType: this.incomeType,
      archived: this.archived
    }
  }

  static MaxQCD = 100000
}

export default AssetConversion